// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9AC0CD', // Accent color
      contrastText: '#E0E4ED',
    },
    secondary: {
      main: '#A1D1F0', // Cool Gray
      contrastText: '#E0E4ED',
    },
    background: {
      default: '#040813', // Base background
      paper: '#081529', // Paper components
    },
    text: {
      primary: '#E0E4ED',
      secondary: '#D1E5F0',
    },
    action: {
      hover: 'rgba(154, 192, 205, 0.1)', // Hover effects
    },
    custom: {
      gradientPrimary: 'linear-gradient(135deg, #9AC0CD 0%, #A1D1F0 100%)',
      gradientHover: 'linear-gradient(135deg, #A1D1F0 0%, #9AC0CD 100%)',
      shadowPrimary: 'rgba(154, 192, 205, 0.4)',
      shadowHover: 'rgba(161, 209, 240, 0.6)',
      scrollbar: '#AF3B72',
      // Add more custom colors if needed
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: {
      fontWeight: 700,
      color: '#9AC0CD',
      fontSize: '3rem',
      '@media (min-width:600px)': {
        fontSize: '3.5rem',
      },
      '@media (min-width:960px)': {
        fontSize: '4rem',
      },
    },
    h2: {
      fontWeight: 700,
      color: '#9AC0CD',
      fontSize: '2.5rem',
      '@media (min-width:600px)': {
        fontSize: '3rem',
      },
      '@media (min-width:960px)': {
        fontSize: '3.5rem',
      },
    },
    h3: {
      fontWeight: 700,
      color: '#9AC0CD',
      fontSize: '2rem',
      '@media (min-width:600px)': {
        fontSize: '2.5rem',
      },
      '@media (min-width:960px)': {
        fontSize: '3rem',
      },
    },
    h4: {
      fontWeight: 700,
      color: '#9AC0CD',
      fontSize: '1.75rem',
      '@media (min-width:600px)': {
        fontSize: '2rem',
      },
      '@media (min-width:960px)': {
        fontSize: '2.25rem',
      },
    },
    h5: {
      fontWeight: 600,
      color: '#A1D1F0',
      fontSize: '1.5rem',
      '@media (min-width:600px)': {
        fontSize: '1.75rem',
      },
      '@media (min-width:960px)': {
        fontSize: '2rem',
      },
    },
    body1: {
      color: '#E0E4ED',
      fontSize: '1rem',
      '@media (min-width:600px)': {
        fontSize: '1.125rem',
      },
      '@media (min-width:960px)': {
        fontSize: '1.25rem',
      },
    },
    button: {
      textTransform: 'none', // Prevent uppercase
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px',
          padding: '12px 24px',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          boxShadow: `0 4px 10px ${theme => theme.palette.custom.shadowPrimary}`,
          '&:hover': {
            background: theme => theme.palette.custom.gradientHover,
            transform: 'scale(1.05)',
            boxShadow: `0 6px 15px ${theme => theme.palette.custom.shadowHover}`,
          },
        },
        containedPrimary: {
          background: theme => theme.palette.custom.gradientPrimary,
          color: '#fff',
          '&:hover': {
            background: theme => theme.palette.custom.gradientHover,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-10px)',
            boxShadow: '0 6px 30px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#040813',
          boxShadow: 'none',
          padding: '10px 0',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#081529',
          borderRadius: '16px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          letterSpacing: '0.5px',
          lineHeight: 1.6,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.2)',
          },
        },
      },
    },
  },
});

export default theme;

